import { RHFAutocomplete } from './RHFAutocomplete.js';
import { RHFCheckbox } from './RHFCheckbox.js';
import { RHFColorInput } from './RHFColorInput.js';
import { RHFDatePicker, RHFTimePicker } from './RHFDatePicker.js';
import { RHFPasswordField } from './RHFPasswordField.js';
import { RHFMultiSelect, RHFSelect } from './RHFSelect.js';
import { RHFTextField } from './RHFTextField.js';

// ----------------------------------------------------------------------

export const Field = {
  Autocomplete: RHFAutocomplete,
  Checkbox: RHFCheckbox,
  Text: RHFTextField,
  Password: RHFPasswordField,
  Select: RHFSelect,
  MultiSelect: RHFMultiSelect,
  DatePicker: RHFDatePicker,
  TimePicker: RHFTimePicker,
  ColorInput: RHFColorInput,
};
